import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var SubscriberUnique = /*#__PURE__*/function () {
  function SubscriberUnique(nextHandler, errorHandler) {
    _classCallCheck(this, SubscriberUnique);
    _defineProperty(this, "closed", false);
    _defineProperty(this, "events", new Map());
    _defineProperty(this, "nextHandler", void 0);
    _defineProperty(this, "errorHandler", void 0);
    this.nextHandler = nextHandler;
    this.errorHandler = errorHandler;
  }
  _createClass(SubscriberUnique, [{
    key: "next",
    value: function next(event) {
      this.events.set(event.type, event);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "error",
    value: function error(_error) {
      if (this.errorHandler) {
        this.errorHandler(_error);
      } else {
        this.closed = true;
      }
    }
  }, {
    key: "complete",
    value: function () {
      var _complete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _iterator, _step, _step$value, event, promise;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this.events);
              _context.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 21;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2), event = _step$value[1];
              _context.prev = 5;
              promise = this.nextHandler(event);
              if (!(promise instanceof Promise)) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return promise;
            case 10:
              _context.next = 19;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](5);
              if (!this.errorHandler) {
                _context.next = 18;
                break;
              }
              this.errorHandler(_context.t0);
              _context.next = 19;
              break;
            case 18:
              return _context.abrupt("break", 21);
            case 19:
              _context.next = 3;
              break;
            case 21:
              _context.next = 26;
              break;
            case 23:
              _context.prev = 23;
              _context.t1 = _context["catch"](1);
              _iterator.e(_context.t1);
            case 26:
              _context.prev = 26;
              _iterator.f();
              return _context.finish(26);
            case 29:
              this.events = new Map();
              this.closed = false;
            case 31:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 23, 26, 29], [5, 12]]);
      }));
      function complete() {
        return _complete.apply(this, arguments);
      }
      return complete;
    }()
  }]);
  return SubscriberUnique;
}();